<template>
    <div class="content-container">
        <el-scrollbar>
            <div class="ala-container" v-loading="loading">
                <div class="top-wrap flex">
                    <div class="left">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/' }">{{ $t('home') }}</el-breadcrumb-item>
                            <el-breadcrumb-item> {{ review_group_detail.name }}</el-breadcrumb-item>
                        </el-breadcrumb>
                        <div class="title">
                        </div>
                    </div>
                </div>
                <div class="ala-flex is-between is-center">
                    <div class="top-tab">
                        <div :class="tab_value==='undone'? 'active tab-item':'tab-item' " @click="toChangeTab('undone')">
                            {{$t('unReview')}} ({{  undoneList.length}})
                        </div>
                        <div :class="tab_value==='staging'? 'active tab-item':'tab-item' " @click="toChangeTab('staging')">
                            {{$t('unSubmit')}} ({{ stagingList.length  }})
                        </div>
                        <div :class="tab_value==='done'? 'active tab-item':'tab-item' " @click="toChangeTab('done')">
                            {{$t('isSubmit')}} ({{ doneList.length }})
                        </div>
                        <!-- <div class="left">
                            <el-button class="active">待评审(12)</el-button>
                            <el-button>已完成(3)</el-button>
                        </div> -->
                        
                    </div>          
                    <div class="tip">
                        {{$t('tongguolv')}} {{ passing_rate }}%
                    </div>
                </div>
                
                <div class="content-wrap no-mar">
                    <div class="sub-button" v-if="tab_value === 'staging'">
                        <el-button type="primary" :disabled="(stagingList.length === 0)||(first_status==='end'&&review_option==='first')||(second_status==='end'&&review_option==='second')"  @click="toSubmit">提交评审</el-button>
                    </div>
                    <div class="table-list">
                        <el-table :data="tableData" size="medium" :empty-text="emptyText">
                            <el-table-column prop="code" width="140" label="IDMIC ID">
                            </el-table-column>
                            <el-table-column prop="name" min-width="25%" :label="$t('workName')">
                                <!-- <template slot-scope="scope">
                                    <div class="hover-color" @click="toDetail(scope.row)">
                                        {{ scope.row.name }}
                                    </div>
                                </template> -->
                            </el-table-column>
                           
                            <el-table-column prop="contribution.name" min-width="25%" :label="$t('type')">
                            </el-table-column>
                            <el-table-column prop="file.name" min-width="25%" :label="$t('file')">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.file">{{ scope.row.file.name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="file.name" width="100" label="文件大小">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.file">
                                        <span v-if="scope.row.file.size<1024">
                                            {{ scope.row.file.size }}KB
                                        </span>
                                        <span v-else>
                                            {{ (scope.row.file.size/1024).toFixed(2) }}MB
                                        </span>
                                        
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="disk_link" min-width="25%" label="工程文件">
                            </el-table-column> -->
                            <el-table-column prop="staging.result" width="120" :label="$t('result')" v-if="tab_value === 'staging'">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.staging">
                                        <div class="tag-box" v-if="review_option === 'first'">
                                            <el-tag v-if="scope.row.staging.result === 1" type="success">{{ $t('tongguo') }}</el-tag>
                                            <el-tag v-else-if="scope.row.staging.result ===  0" type="danger">{{ $t('weitongguo') }}</el-tag>
                                        </div>
                                        <div v-else-if="review_option === 'second'">
                                            {{scope.row.staging.result}}
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            
                            <el-table-column v-if="is_review === '1'"  prop="sort" width="120" :label="$t('result')" align="center">
                                <template slot-scope="scope">
                                    <div class="tag-box" v-if="review_option === 'first'">
                                        <el-tag v-if="scope.row.score === true" type="success">{{ $t('tongguo') }}</el-tag>
                                        <el-tag v-else-if="scope.row.score === false " type="danger">{{ $t('weitongguo') }}</el-tag>
                                    </div>
                                    <div v-else-if="review_option === 'second'">
                                        {{scope.row.score}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column   prop="sort" min-width="20%"  :show-overflow-tooltip="true" :label="$t('pingyu')" v-if="tab_value==='staging' || tab_value==='done'">
                                <template slot-scope="scope" >
                                    <span v-if="scope.row.staging">
                                        {{scope.row.staging.review_reason}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if=" review_option === 'first' && tab_value !=='undone'"  prop="staging.level" width="120" :label="$t('lev')" align="center">
                            </el-table-column>
                            <el-table-column  prop="sort" width="120" :label="$t('op')" align="center">
                                <template slot-scope="scope">
                                    <el-button :disabled="(first_status==='end'&&review_option==='first')||(second_status==='end'&&review_option==='second')"  type="text" @click="toGrade(scope.row)">
                                        <span v-if="is_review === '2'">
                                            <template v-if="tab_value==='staging'">{{ $t('edit') }}</template>
                                            <template v-else>{{ $t('toPingshen') }}</template>
                                        </span>
                                    </el-button>
                                    <el-button v-if="is_review === '1'"  type="text" @click="toGrade(scope.row)">
                                        <span>{{ $t('detail') }}</span>
                                    </el-button>
                                </template>
                            </el-table-column>
                            
                        </el-table>
                        
                       
                    </div>
                </div>
            </div>
        </el-scrollbar>
        <!-- 评审弹窗 -->
        <el-dialog
        custom-class="dialog_tc review-dialog"
        :title="detailData.name"
        :visible.sync="gradeDialog"
        width="100%"
        center
        :before-close="handleCloseReview"
        >
        <el-row :gutter="10" type="flex">
            <el-col :span="12">
                <div class="review-dialog-item">
                    <div class="title">
                        {{ $t('file') }}
                    </div>
                    <div class="play-content" v-if="detailData.file">
                        <div class="video-wrap"  v-if="isVideo">
                            <div class="video-box">
                                <video ref="videoPlayer"  class="video-play" :src="detailData.file.auth_url" controls ></video>
                            </div>
                        </div>
                        <audio ref="audioPlayer" v-if="isAudio" class="audio-box"  :src="detailData.file.auth_url" controls></audio>
                    </div>
                </div>
                
            </el-col>
            <!-- <el-col :span="12" v-if="detailData.lyrics">
                <div class="review-dialog-item">
                    <div class="title">
                        歌词
                    </div>
                    <iframe  :src="lyrics_path" style="height: 290px" width="100%" frameborder="0"></iframe>
                </div>

            </el-col> -->
            <el-col :span="12" v-if="detailData.report">
                <div class="review-dialog-item">
                    <div class="title">
                        {{ $t('report') }}
                    </div>
                    <iframe v-if="report_path"  :src="report_path" style="height: calc(100% - 26px);flex:1;min-height: 45vh;" width="100%" frameborder="0"></iframe>
                </div>
            </el-col>
            <!-- <el-col :span="12" v-if="detailData.disk_link">
                <div class="review-dialog-item">
                    <div class="title">
                        工程文件
                    </div>
                    {{ detailData.disk_link }}
                </div>
            </el-col> -->
            <el-col :span="12">
                <div class="review-dialog-item">
                    <div class="title">
                        {{ $t('toScore') }}
                    </div>
                    <el-form
                        ref="selectionsForm"
                        :model="gradeForm"
                        size="medium"
                    >
                        <el-form-item v-if="review_option === 'second'">
                            <div v-if="is_review === '1'">
                                <span>{{$t('score')}} {{ gradeForm.result }}</span>
                            </div>
                            <el-input-number 
                                v-else
                                :placeholder="$t('inputScore')"
                                v-model="gradeForm.result"
                                :precision="0"
                                :min="0"
                                :max="100"
                                controls-position="right"
                            ></el-input-number>
                        </el-form-item>
                        <el-form-item v-if="review_option === 'first'" class="radio-box">
                            <div v-if="is_review === '1'">
                                <span>{{ $t('istongguo') }}</span>
                                <el-tag v-if="gradeForm.result === 1" type="success">{{ $t('tongguo') }}</el-tag>
                                <el-tag v-else-if="gradeForm.result ===  0" type="danger">{{ $t('weitongguo') }}</el-tag>
                            </div>
                            <div v-else>
                                <span>{{ $t('istongguo') }}</span>
                                <el-radio v-model="gradeForm.result" :label=1>{{ $t('tongguo') }}</el-radio>
                                <el-radio v-model="gradeForm.result" :label=0>{{ $t('weitongguo') }}</el-radio>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="review_option === 'first'" class="radio-box">
                            <div v-if="is_review === '1'">
                                <span>{{ $t('reviewLev') }}</span>
                                {{ gradeForm.level }}
                            </div>
                            <div v-else>
                                <span>{{ $t('reviewLev') }}</span>
                                <el-radio v-for="item in levelOption" :key="item" v-model="gradeForm.level" :label='item'>{{ item }}</el-radio>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <span v-if="is_review === '1'">{{ $t('pingyu') }} {{ gradeForm.review_reason }}</span>
                            <el-input v-else
                                type="textarea"
                                rows="2"
                                :placeholder="$t('inputPingyu')"
                                v-model="gradeForm.review_reason"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                
            </el-col>
        </el-row>  
        
        <span slot="footer" class="dialog-footer" v-if="is_review === '2'">
            <el-button size="small" @click="toClose">{{ $t('cancel') }}</el-button>
            <el-button size="small" type="primary" @click="toSaveGrade"
            >{{ $t('yes') }}</el-button
            >
        </span>
        </el-dialog>
        <!-- 播放弹窗 -->
        <el-dialog
          custom-class="dialog_tc"
          title=""
          :visible.sync="playDialog"
          width="680px"
        >
          <div class="play-content" v-if="detailData.file">
            <div class="video-wrap"  v-if="isVideo">
              <div class="video-box">
                <video  class="video-play" :src="detailData.file.auth_url" controls ></video>
              </div>
            </div>
            <audio v-if="isAudio" class="audio-box"  :src="detailData.file.auth_url" controls></audio>
          </div>
        </el-dialog>
        <!-- 详情弹窗 -->
        <el-drawer custom-class="drawer_tc detail_tc" :title="$t('workDetail')" :visible.sync="drawerDetail" direction="rtl" size="55%">
            <div class="drawer-body">
                <el-scrollbar>
                    <div class="drawer-content">
                        <div class="form-detail">
                            <el-form ef="detailData" :model="detailData" label-width="80px">
                                <el-row :gutter="20">
                                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <div class="title">
                                            {{ $t('baseInfo') }}
                                        </div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item label="IDMIC ID：">
                                            <div class="desc">
                                                {{ detailData.code }}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item :label="$t('workName')">
                                            <div class="desc">
                                                {{ detailData.name }}
                                            </div>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item :label="$t('type')" v-if="detailData.contribution">
                                            <div class="desc">
                                                {{ detailData.contribution.name }}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item label="赛区名称：" v-if="detailData.area">
                                            <div class="desc">
                                                {{ detailData.area.name }}
                                            </div>
                                        </el-form-item>
                                    </el-col> -->
                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item :label="$t('author')">
                                            <div class="desc">
                                                {{ detailData.user.name }}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item :label="$t('tel')">
                                            <div class="desc">
                                                {{ detailData.user.mobile }}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item :label="$t('mail')">
                                            <div class="desc">
                                                {{ detailData.user.email }}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item :label="$t('cardType')">
                                            <div class="desc">
                                                {{ detailData.user.credential_id }}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item :label="$t('cardCode')">
                                            <div class="desc">
                                                {{ detailData.user.credential_code }}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item label="NCDA：">
                                            <div class="desc">
                                                {{ detailData.ncda_code}}
                                            </div>
                                        </el-form-item>
                                    </el-col> -->
                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <el-form-item :label="$t('panlink')">
                                            <div class="desc">
                                                {{ detailData.disk_link}}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <el-form-item :label="$t('workintro')">
                                            <div class="desc">
                                                {{ detailData.remark}}
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <div class="title">
                                            {{ $t('workFile') }}
                                        </div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <el-form-item label-width="0px" v-if="detailData.file">
                                            <div class="video-wrap"  v-if="isVideo">
                                                <div class="video-content">
                                                    <div class="video-box">
                                                    <video  class="video-play" :src="detailData.file.auth_url" controls></video>
                                                    </div>
                                                </div>
                                            </div>
                                            <audio v-if="isAudio" class="audio-box"  :src="detailData.file.auth_url" controls></audio>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import  { apiWork,apiReviewGroupDetail,apiGrade,apiCurrentRound ,apiGradeStaging,apiGetLevel} from "../plugins/api";
import  {  checkRoundTime } from "../plugins/common";
export default {
    data() {
        return {
            
            round_id:"",
            review_option:"",
            review_group_id:"",
            review_group_detail:"",
            is_review:"2",
            doneTotal:"",
            work_id:"",
            gradeForm:{
                result:"",
                review_reason:"",
                level:"",
            },
            tableData: [
            ],
            emptyText: this.$t('loading'),
            drawerDetail: false,
            detailData:{
                contribution:{},
                file:{},
                user:{},
                area:{},
            },
            playDialog: false,
            gradeDialog: false,
            first_status:"",
            second_status:"",
            loading:true,
            stagingList:[],
            undoneList:[],
            doneList:[],
            tab_value:"undone",
            lyrics_path:"",
            report_path:"",
            levelOption:[],
            work_total:0,
            passing_rate:0,
            isVideo:false,
            isAudio:false,
        };
    },
    components:{
    },
    async mounted() {
        this.round_id = this.$route.query.round_id
        this.review_option = this.$route.query.review_option
        this.review_group_id = this.$route.query.review_group_id
        this.is_review = this.$route.query.is_review
        await this.view()
        await this.getGroupDetail()
        await this.getCurrentRound()
        await this.doneReview()
        await this.getLevelOption()
        this.getWorkPass()
        // await this.undoneReview()
        this.emptyText = this.$t('empty')
        this.loading = false

    },
    methods: {
        async view() {
            let _data = {
                round_id:this.round_id,
                review_option:this.review_option,
                review_group_id:this.review_group_id,
                is_review:this.is_review,
            }
            let res = await apiWork(_data);
            if (res.code === 200) {
                this.tableData = res.data
                if(this.is_review === '2'){
                    let stagingList = [],undoneList = []
                    for(let item of res.data){
                        if(item.staging === null){
                            undoneList.push(item)
                        }else{
                            stagingList.push(item)
                        }
                    }
                    this.stagingList = stagingList
                    this.undoneList = undoneList
                    
                }else if(this.is_review === '1'){
                    this.doneTotal = res.data.length;
                    this.doneList = res.data
                }
                if(this.tab_value === "undone"){
                    this.tableData = this.undoneList
                }else if(this.tab_value === "staging"){
                    this.tableData = this.stagingList
                }else if(this.tab_value === "done"){
                    this.tableData = this.doneList
                }
                
            }
         },
         async getCurrentRound(){
            let res = await apiCurrentRound();
            if (res.code === 200) {
                this.first_status = checkRoundTime(res.data.first_review_start_time,res.data.first_review_end_time)
                this.second_status = checkRoundTime(res.data.second_review_start_time,res.data.second_review_end_time)
                console.log(111,this.first_status);
            }
        },
        toClose(){
            this.gradeDialog=false
            if(this.detailData.file){
                if(this.isVideo){
                    this.$refs.videoPlayer.pause()
                }
                if(this.isAudio){
                    this.$refs.audioPlayer.pause()
                }
            }
        },
        async getLevelOption(){
            let res = await apiGetLevel();
            if (res.code === 200) {
               this.levelOption = res.data
            }
        },
         async doneReview() {
            let _data = {
                round_id:this.round_id,
                review_option:this.review_option,
                review_group_id:this.review_group_id,
                is_review:'1',
            }
            let res = await apiWork(_data);
            if (res.code === 200) {
                this.doneList = res.data;
            }
         },
         getWorkPass(){
            this.work_total = this.doneList.length +  this.stagingList.length + this.undoneList.length
            let stagingPassNum = 0
            let donePassNum = 0
            for(let item of this.stagingList){
                if(item.staging.result === 1){
                    stagingPassNum ++
                }
            }
            for(let item of this.doneList){
                if(item.score === true){
                    donePassNum ++
                }
            }
            this.passing_rate = (((stagingPassNum + donePassNum) / this.work_total ).toFixed(2))*100

         },
         async getGroupDetail(){
            let res = await apiReviewGroupDetail(this.review_group_id);
            if (res.code === 200) {
                this.review_group_detail = res.data[0];
            }
        },
        handleCloseReview(done){
            if(this.detailData.file){
                if(this.isVideo){
                    this.$refs.videoPlayer.pause()
                }
                if(this.isAudio){
                    this.$refs.audioPlayer.pause()
                }
            }
            done();
        },
        async toChangeTab(data){
            this.tab_value = data
            if(this.tab_value === "done"){
                this.is_review = "1"
            }else{
                this.is_review = "2"
            }
            await this.view()
        },
        toDetail(data) {
            this.drawerDetail = true
            this.detailData = data
        },
        toOpenFile(data) {
            this.playDialog = true
            this.detailData = data
        },
        toGrade(data){
            this.detailData = data
            console.log(222, this.detailData.file);
            if(this.detailData.file){
                if(this.detailData.file.path.substr(-3) === 'mp4' || this.detailData.file.path.substr(-3) === 'mov' || this.detailData.file.path.substr(-3) === 'MP4'){
                    this.isVideo = true
                    this.isAudio = false
                }else{
                    this.isAudio = true
                    this.isVideo = false
                }
            }
            
            if(this.detailData.lyrics != null){
                this.lyrics_path = this.detailData.lyrics.client_uri + this.detailData.lyrics.path
            }
            if(this.detailData.report != null){
                this.report_path = this.detailData.report.client_uri + this.detailData.report.path
            }
            // if(this.detailData.lyrics || this.detailData.report){
            //     this.lyrics_path = this.detailData.lyrics.client_uri + this.detailData.lyrics.path
            //     this.report_path = this.detailData.report.client_uri + this.detailData.report.path
            // }
            
            this.gradeDialog = true
            if(data.staging){
                this.gradeForm =JSON.parse(JSON.stringify(data.staging)) 
            }else{
                this.gradeForm = {}
            }
            this.work_id = data.id
        },
       
        async toSaveGrade(){

            let _data = {
                work_id:this.work_id,
                review_group_id:this.review_group_id,
                result:this.gradeForm.result,
                review_reason:this.gradeForm.review_reason,
                level:this.gradeForm.level,
                option:this.review_option,
            }
            let res = await apiGradeStaging(_data);
            if (res.code === 200) {
                this.gradeDialog = false

                if(this.detailData.file){
                    if(this.isVideo){
                        this.$refs.videoPlayer.pause()
                    }
                    if(this.isAudio){
                        this.$refs.audioPlayer.pause()
                    }
                }
                await this.view()
                await this.doneReview()
                this.getWorkPass()
            }
        },
        async toSubmit(){
            this.$confirm(this.$t('submitConfirm'), "", {
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('cancel2'),
                type: "warning",
                center: true,
                })
                .then(async () => {
                    let _data = {
                        review_group_id:this.review_group_id,
                        gradeData:this.stagingList.map(item => {
                            return {
                                id:item.id,
                            }
                        }),
                        option:this.review_option,
                    }
                    let res = await apiGrade(_data);
                    if (res.code === 200) {
                        await this.view()
                        await this.doneReview()
                    }else{
                        this.$message.error(res.message)
                    }
                })
                .catch(() => {
                    // this.$message.success("取消成功")
            });
            
        }
    },
};
</script>